module.exports = __webpack_public_path__ + "static/media/Hypoalergenni_sprchovy_olej_s_Omega369_retina.4ea83fde.jpg";